export const WLAS_SUPPORT_PHONE = '+43 (0)5 1758-100';
export const WLAS_SUPPORT_EMAIL = 'office@propileya.at';
